export default "__VITE_ASSET__DoOzBtCA__"